export const MIS_FIELDS_CLAIMS = [
  "SR. No",
  "Claim ID",
  "PNR ",
  "Train No",
  "Travel Date",
  "Ticket Fare (₹)",
  "Waitlist After Chart (Y/N)",
  "Claim Received Date",
  "Claim Approved (Y/N)",
  "Claim Amount (₹)",
  "Settlement Date",
  "Mode of Payment",
];

// MIS export field configuration
export const MIS_FIELDS_BOOKINGS = [
  "Sr No",
  "Date",
  "Transaction ID",
  "PNR",
  "Train No",
  "Train Name",
  "Travel Date",
  "Boarding",
  "Destination",
  "Ticket Fare (₹)",
  "Confirmation Probability at Sale (%)",
  "Product Issued (Y/N)",
  "Premium (₹)",
  "Status",
];

export const MIS_FIELDS_ACTIVEJOURNEY = [
  "SR. No ",
  "PNR",
  "Train No",
  "Travel Date",
  "Chart Preparation Time",
  "Final Waitlist Status",
  "Final Probability (%)",
  "Product Active (Y/N)",
  "Expected Claim Amount (₹)",
];

export const MIS_FIELDS_OTAPARTNER = [
  "Sr No",
  "Partner Name",
  "Date",
  "Searches",
  "Eligible Policies Shown",
  "Policies Sold",
  "Conversion %",
  "Total Premium (₹)",
  "Claims Count",
  "Claim Ratio (%)",
];

export const MIS_FIELDS_PROBABILITYMONITORING = [
  "Sr No",
  "PNR",
  "Train No",
  "Travel Date",
  "Initial Probability (%)",
  "Updated Probability (%)",
  "Timestamp",
  "Product Displayed (Y/N)",
  "Auto Removal Triggered (Y/N)",
];

export const MIS_FIELDS_REVENUE = [
  "Sr No",
  "Month",
  "Total Policies Sold",
  "Total Premium Collected (₹)",
  "Total Claims Paid (₹)",
  "Loss Ratio (%)",
  "Net Revenue (₹)",
];

export const MIS_FIELDS_TRAINWISEPERFORMANCE = [
  "Sr No",
  "Train No",
  "Train Name",
  "Total Searches",
  "Probability Trend Avg (%)",
  "Eligible Policies Offered",
  "Policies Sold",
  "Claims Triggered",
  "Claims %",
];

export const FIELDS_VOUCHERS = [
  "SR. No ",
  "voucher code ",
  "PNR Number",
  "Partner ID",
  "Refund Amount",
  "Redeemed Amount",
];

export const FIELDS_CLAIMS_REJECTIONS = [
  "SR. No ",
  "Claim ID",
  "PNR",
  "Customer Name",
  "Train Number",
  "Travel Date",
  "Rejection Reason",
  "Uploaded Proof Status",
  "Remarks",
];

export const MIS_FIELDS_CDBALANCE = [
  "SR. No ",
  "Updated By",
  "Txn Type",
  "Mode",
  "Date",
  "Status",
  "Updated Amount",
  "Txn Amount",
];
